import MaterialSinglePropertyAssigner from "../../../output/assets/materials/material-single-property-assigner.js";

class ThreeGLRaycastMaterialOwnerAssigner extends MaterialSinglePropertyAssigner {
    constructor() {
        super();
    }

    setProperty(material, slot) {
        material.uniforms.worldObjectId.value = slot.id;
    }
}

export default ThreeGLRaycastMaterialOwnerAssigner;
